import React, { useState } from "react";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import TableChartIcon from "@mui/icons-material/TableChart";
import VerifiedIcon from "@mui/icons-material/Verified";
import TabCaricaEstrai from "./components/tabs/TabCaricaEstrai";
import TabTabelleImpostazioni from "./components/tabs/TabTabelleImpostazioni";
import TabValidazione from "./components/tabs/TabValidazione";

const CustomTabPanel = (props) => {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tariffe-tabpanel-${index}`}
      aria-labelledby={`tariffe-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
};

const TariffeFornitori = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [tariffe, setTariffe] = useState([]);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [idCounter, setIdCounter] = useState(0);
  
  // Stato per TabCaricaEstrai - persiste tra i cambi tab
  const [uploadState, setUploadState] = useState({
    uploadedFile: null,
    isAnalyzing: false,
    analysisError: null,
    extractedData: null,
    validationResult: null,
  });

  const handleTabChange = (event, newValue) => {
    if (hasUnsavedChanges) {
      if (window.confirm("Hai modifiche non salvate. Vuoi continuare?")) {
        setActiveTab(newValue);
        setHasUnsavedChanges(false);
      }
    } else {
      setActiveTab(newValue);
    }
  };

  const handleAddTariff = (newTariff) => {
    // Se è un array di tariffe, aggiungile tutte insieme
    if (Array.isArray(newTariff)) {
      const baseTime = Date.now();
      const tariffeWithIds = newTariff.map((tariff, index) => ({
        ...tariff,
        id: baseTime + index,
        dataCreazione: new Date().toISOString(),
        ultimoAggiornamento: new Date().toISOString(),
        attivo: tariff.attivo !== undefined ? tariff.attivo : true,
      }));
      setTariffe((prev) => [...prev, ...tariffeWithIds]);
      setIdCounter(prev => prev + newTariff.length);
    } else {
      // Singola tariffa
      const newId = Date.now() + idCounter;
      setIdCounter(prev => prev + 1);
      
      const tariffWithId = {
        ...newTariff,
        id: newId,
        dataCreazione: new Date().toISOString(),
        ultimoAggiornamento: new Date().toISOString(),
        attivo: newTariff.attivo !== undefined ? newTariff.attivo : true,
      };
      setTariffe((prev) => [...prev, tariffWithId]);
    }
  };

  const handleUpdateTariff = (id, updates) => {
    setTariffe((prev) =>
      prev.map((t) =>
        t.id === id
          ? { ...t, ...updates, ultimoAggiornamento: new Date().toISOString() }
          : t
      )
    );
    setHasUnsavedChanges(true);
  };

  const handleDeleteTariff = (id) => {
    if (window.confirm("Sei sicuro di voler eliminare questa tariffa?")) {
      setTariffe((prev) => prev.filter((t) => t.id !== id));
    }
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" fontWeight={700} gutterBottom>
          Gestione Tariffe Fornitori
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Importa, gestisci e valida le tariffe energetiche tramite AI
        </Typography>
      </Box>

      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={activeTab} onChange={handleTabChange}>
          <Tab
            icon={<UploadFileIcon />}
            iconPosition="start"
            label="Carica & Estrai"
          />
          <Tab
            icon={<TableChartIcon />}
            iconPosition="start"
            label="Tabelle Impostazioni"
          />
          <Tab
            icon={<VerifiedIcon />}
            iconPosition="start"
            label="Validazione"
          />
        </Tabs>
      </Box>

      <CustomTabPanel value={activeTab} index={0}>
        <TabCaricaEstrai 
          onAddTariff={handleAddTariff}
          uploadState={uploadState}
          setUploadState={setUploadState}
        />
      </CustomTabPanel>

      <CustomTabPanel value={activeTab} index={1}>
        <TabTabelleImpostazioni
          tariffe={tariffe}
          onUpdateTariff={handleUpdateTariff}
          onDeleteTariff={handleDeleteTariff}
          onAddTariff={handleAddTariff}
        />
      </CustomTabPanel>

      <CustomTabPanel value={activeTab} index={2}>
        <TabValidazione
          tariffe={tariffe}
          onUpdateTariff={handleUpdateTariff}
        />
      </CustomTabPanel>
    </Box>
  );
};

export default TariffeFornitori;
